import { ACoreXUIModule } from '@acorex/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AXFEditorService } from '../../../services/editor.service';
import { AXFDropdownEditorComponent } from './dropdown.editor';

@NgModule({
  declarations: [AXFDropdownEditorComponent],
  imports: [CommonModule, ACoreXUIModule],
  exports: [AXFDropdownEditorComponent],
  entryComponents: [AXFDropdownEditorComponent],
  providers: [],
})
export class AXFDropdownEditorModule {
  constructor(service: AXFEditorService) {
    service.register('DropdownEditor', AXFDropdownEditorComponent);
  }
}
